<template>
  <section class="utils-bar ub">
    <!-- <button @click="copyToClipboard" class="utils-bar__tag-button">
      #{{ utilsBar[curLang].campaignTag }}
      <span class="utils-bar__tag-button-triangle"></span>
      <input class="utils-bar__tag-input" type="hidden" :value="`#${utilsBar[curLang].campaignTag}`" />
    </button> -->
    <!-- mu = Museum -->
    <!-- This is (muIconButton) an example of a *globally* registered component. -->
    <!-- <muIconButton
      @click="copyToClipboard"
      :text="utilsBar[curLang].buttonTickets.text"
      :href="utilsBar[curLang].buttonTickets.href"
      :icon="'ticket'"
      :subClasses="['utils-bar', 'ub-tickets']"
    /> -->
    <muIconButton
      :scrollTopHandler="true"
      :text="utilsBar[curLang].buttonTop.text"
      :href="`#${utilsBar[curLang].buttonTop.hrefHash}`"
      :icon="'arrow_upward'"
      :subClasses="['utils-bar', 'ub-top']"
    />
  </section>
</template>
<script>
export default {
  data() {
    return {
      curLang: this.$store.getters.getAppLang,
      utilsBar: {
        en: {
          campaignTag: 'RemembranceDay',
          buttonTickets: {
            href: '#buy-tickets',
            text: 'Buy Tickets'
          },
          buttonTop: {
            hrefHash: 'top',
            text: 'Back to Top'
          }
        },
        fr: {
          campaignTag: 'ViesTransformées2GM',
          buttonTickets: {
            href: '#acheter-billets',
            text: 'Acheter des billets'
          },
          buttonTop: {
            hrefHash: 'haut',
            text: 'Haut'
          }
        }
      }
    };
  },
  methods: {
    copyToClipboard(e) {
      const tagInputEl = document.querySelector('.utils-bar__tag-input');
      tagInputEl.setAttribute('type', 'text');
      tagInputEl.select();
      document.execCommand('copy');
      // And hide.
      tagInputEl.setAttribute('type', 'hidden');
    }
  },
  computed: {}
};
</script>